export default {
  "01": {
    description: "Il faut s'assurer dans ce contrôle que le solde de la BG soit bien à zéro.",
    actions: "Dans le cas échéant, justifier l'écart.",
  },
  "02": {
    description: "Ce test a pour but de contrôler le résultat avec celui de SAP.",
    actions: "Faire une capture d'écran du résultat SAP (F.01) et coller dans la partie commentaires.",
  },
  "03": {
    description: "Ce test consiste à contrôler et justifier les sens des comptes.",
    actions: "Commenter tous les comptes avec un commentaire \"A analyser\"",
  },
  "04": {
    description: "Ce test consiste à s'assurer que les comptes d'attente et divers soient justifié.",
    actions: "Commenter les soldes différents de zéro (captures d'écran, mails justificatifs, etc)",
  },
  "05": {
    description: "Ce teste consiste à contrôler les soldes des éléments OTP. Les EOTP activables doivent être à zéro.",
    actions: "Faire un ticket à destination du CDG pour lancer l'activation des éléments manquants",
  },
  "06": {
    description: "Ce teste consiste à contrôler le solde des éléments OTP R22 (financier).",
    actions: "Faire un ticket à destination du CDG pour lancer l'activation des éléments manquants",
  },
  "07": {
    description: "Ce teste consiste à contrôler les soldes des centres de coûts. Ils doivent être à zéro",
    actions: "Reclasser les lignes non soldées.",
  },
  "A1": {
    description: "Ce test consiste à contrôler les opérations non affectées dans les comptes #511.",
    actions: `
      Les seules écritures tolérées sont :
      <br/>
      - les opérations non identifiables (faisant l'objet d'une demande par mail),
      <br/>
      - les opérations d'anticipation de trésorerie (prélèvements à venir, encaissements de production,etc)
      <br/>
      - écritures liées à la campagne de règlement (pièces ZP)
    `,
  },
  "A2": {
    description: "Ce test consiste à contrôler et justifier les soldes 512.",
    actions: "Justifier les soldes dans la partie commentaires avec des captures d'écran à l'aide des RUBY à date du jour.",
  },
  "A3": {
    description: "Ce test consite à contrôler et justifier les opérations liées au financement par crédit bail.",
    actions: `
      - Compléter les cases de la colonne échéancier à l'aide du fichier de suivi.
      <br/>
      - comptabiliser les élements manquants et justifier les écarts
      <br/>
      <br/>
      Si la société n'est pas concernée, commenter "NC"
    `,
  },
  "A4": {
    description: "Ce test consite à contrôler et justifier les opérations liés au financement par LOAN",
    actions: `
      - Compléter les cases de la colonne échéancier à l'aide du fichier de suivi.
      <br/>
      - comptabiliser les élements manquants et justifier les écarts
      <br/>
      <br/>
      Si la société n'est pas concernée, commenter "NC"
    `,
  },
  "A5": {
    description: "Ce test consite à contrôler et justifier les opérations liés au financement SWAP",
    actions: `
      - Compléter les cases de la colonne échéancier à l'aide du fichier de suivi.
      <br/>
      - comptabiliser les élements manquants et justifier les écarts
      <br/>
      <br/>
      Si la société n'est pas concernée, commenter "NC"
    `,
  },
  "A6": {
    description: "Ce test consite à contrôler et justifier les opérations liés au financement par Prêt actionnaire externe.",
    actions: `
      - Compléter les cases de la colonne échéancier à l'aide du fichier de suivi.
      <br/>
      - comptabiliser les élements manquants et justifier les écarts
      <br/>
      <br/>
      Si la société n'est pas concernée, commenter "NC"
    `,
  },
  "A7": {
    description: "Ce test consite à contrôler et justifier les opérations liés au financement par compte courant externe.",
    actions: `
      - Compléter les cases de la colonne échéancier à l'aide du fichier de suivi.
      <br/>
      - Comptabiliser les élements manquants et justifier les écarts
      <br/>
      Si la société n'est pas concernée, commenter "NC"
    `,
  },
  "A8": {
    description: "Ce test consite à contrôler et justifier les écritures de frais d'emprunt à répartir.",
    actions: `
      - Compléter les cases de la colonne échéancier à l'aide du fichier de suivi de financement de la société (disponible sur le SharePoint de la société)
      <br/>
      Si la société n'est pas concernée, commenter "NC"
    `,
  },
  "B1": {
    description: "Ce test consite à contrôler et justifier les soldes des comptes fournisseurs auxiliaire.",
    actions: "Justifier les soldes débiteurs et comptabiliser les FNP en période de clôture (en fonction des seuils)",
  },
  "B2": {
    description: "Ce test consite à contrôler et justifier les soldes des comptes d'acomptes  auxiliarisés.",
    actions: "contrôler les documents sur le sharepoint",
  },
  "B3.1": {
    description: "Ce test consiste à faire l'analyse des charges de la société sur la période en cours.",
    actions: `
      - Contrôler la bonne imputation comptable des comptes
      --> Reclasser (si besoin) les imputations erronées
      <br/>
      - Contrôler la bonne imputation analytiques des écritures comptables
      --> Reclasser (si besoin) les imputations erronées
      <br/>
      - Identifier les éventuelles écritures d'inventaires à comptabliser (Exemple : CCA Manuelle, FNP manuelle, etc)
    `,
  },
  "B3.2": {
    description: "Ce test consite à contrôler la variation des comptes de charges et de FNP sur 2 périodes.",
    actions: "Commenter les soldes avec un contrôle KO.",
  },
  "B3.3": {
    description: "Ce test consiste à contrôler la cohérence des charges sur la période d'analyse par projet (pour les sociétés multi-projet)",
    actions: "Justifier les périodes incohérente (Exemple : factures 2023 reçu au T4 2023 pour l'électricité)",
  },
  "B4": {
    description: "Ce test consite à justifier les soldes de comptes CCA avec la table des contrats SAP.",
    actions: "Commenter et justifier les écarts (Exemple : CCA comptabilisée manuellement, CCA obsolète devant être extournée)",
  },
  "B5": {
    description: "Ce test consite à contrôler le solde de chaque commande.",
    actions: `
      Pour les contrôles KO : Comptabiliser (en fonction des seuils) une FNP manuelle
      <br/>
      Pour les contrôle A lettrer :
      Lancer la transaction F.13 pour lettrer le compte 408
    `,
  },
  "B6": {
    description: "Ce test consite à cadrer les FNP comptabilisées manuellement avec les justificatifs (fichier client). Les FNP Mazars doivent également être justifiées.",
    actions: "Mettre une capture d'écrant ou ajouter en PJ les justificatifs.",
  },
  "B7": {
    description: "Ce test consite à contrôler la cohérence entre les FNP comptabilisée sur les loyer et le calcul théorique sur la base des contrats SAP.",
    actions: "Justifier les écarts",
  },
  "D1.1": {
    description: "Ce test consiste à faire l'analyse des produits de la société sur la période en cours.",
    actions: `
      - Contrôler les périodicité des produits (1 facture de vente par période)
      <br/>
      - Contrôler la bonne imputation analytiques des écritures comptables
      --> Reclasser (si besoin) les imputations erronées
      <br/>
      - Contrôler les S/L partner et corriger si besoin
    `,
  },
  "D1.2": {
    description: "Ce test consite à contrôler la variation des comptes de produits et de FAE/AAE sur 2  périodes.",
    actions: "Commenter les soldes avec un contrôle KO.",
  },
  "D1.3": {
    description: "Ce test consiste à contrôler la cohérence des produits sur la période d'analyse par projet (pour les sociétés multi-projet)",
    actions: "Justifier les périodes incohérentes",
  },
  "D2": {
    description: "Ce test consite à contrôler les comptes clients auxiliaire, d'identifier les factures dont le règlement est à anticiper.",
    actions: "Saisir dans la zone commentaires et analyses comptables les actions réalisées. (anticipations d'encaissement)",
  },
  "D3": {
    description: "Ce test consite à cadrer les FAE/AAE  comptabilisées manuellement avec les justificatifs (fichier client). Les écritures Mazars doivent également être justifiées.",
    actions: "Mettre une capture d'écrant ou ajouter en PJ les justificatifs.",
  },
  "E1": {
    description: "Ce test consite à cadrer les écritures de stocks comptabilisées manuellement avec les justificatifs (fichier client).",
    actions: "Mettre une capture d'écrant ou ajouter en PJ les justificatifs. Si la société n'est pas concernée, commenter \"NC\"",
  },
  "K1": {
    description: "Ce test consite à contrôler la réciprocité des opérations intra groupe.",
    actions: "Mettre une capture d'écran de la ZFIR04 et commenter les écarts.",
  },
  "F1": {
    description: "Ce test consite à contrôler la cohérence entre la comptabilité SAP et le module immobilisation SAP.",
    actions: "Justifier les contrôles KO dans la zone commentaires",
  },
  "F2": {
    description: "Ce test consite à contrôler la cohérence des VNC des immobilisations de la société. La VNC (Valeur nette comptable) doit être supérieure à zéro.",
    actions: "Justifier dans la zone commentaire les contrôles \"A analyser\"",
  },
  "I1": {
    description: "Ce test consiste à contrôler les soldes des comptes de TVA.",
    actions: `
      44566000 : Doit être égal à zéro, sinon justifier dans la zone commentaire la raison du contrôle KO.
      <br/>
      44567000 : Si le contrôle est KO (solde supérieur à 200 000 €) Il faut s'assurer qu'une demande de remboursement de crédit de tva est en cours.
      <br/>
      44566001 : Contrôler dans ce compte l'antériorité des opérations et justifier celle qui sont supérieure à 3 mois dans la zone commentaire.
      <br/>
      445662/44572 : Ces comptes doivent avoir le même solde.
    `,
  },
  "I2": {
    description: `
      Contrôle des opérations liées à l'IS.
      <br/><br/>
      <b>4440000 / BILAN IS</b>
      <br/>
      <b>Action</b> : Saisir les acomptes payés dans chaque cellule si concernées.
      <br/><br/>
      <b>Analyse</b> : Le contrôle doit être à zéro, cela veut dire que le solde comptable correspond aux acomptes payés.
      Justifier les écarts
      <br/><br/>
      <b>695* / COMPTE DE RESULTAT IS</b>
      <br/><br/>
      <b>Action</b> : Saisir le montant de l'acompte d'IS (fichier RF)
      <br/><br/>
      <b>Analyse</b> : Le contrôle doit être à zéro, cela veut dire que le solde comptable correspond au fichier du calcul de l'IS.
      Justifier les écarts
      <br/><br/>
      <b>63710000 / COMPTE DE RESULTAT C3S</b>
      <br/><br/>
      <b>Action</b> : Saisir le montant de la C3S (fichier RF)
      <br/><br/>
      <b>Analyse</b> : Le contrôle doit être à zéro, cela veut dire que le solde comptable correspond au fichier de calcul.
      Justifier les écarts
    `,
  },
  "I3": {
    description: `
      Contrôle des opérations liées aux autres taxes
      <br/><br/>
      <b>CFE</b>
      <br/>
      <b>Actions</b> : Il doit y avoir 1 acompte le 15/06. La taxe est dûe le 15/12
      <br/><br/>
      <b>CVAE</b>
      <br/>
      <b>Actions</b> : Il doit y avoir 2 acomptes, le premier au 15/06 et le second au 15/09.
      <br/><br/>
      <b>Taxe Foncière</b>
      <br/>
      <b>Actions</b> : S'assurer que tous les avis soient sur le SharePoint. A contrôler avec fichier de suivi (récurrent)
      <br/><br/>
      <b>CRIM</b>
      <br/>
      <b>Actions</b> : A contrôler avec fichier de suivi (récurrent)
    `,
  },
  "J1": {
    description: "Ce test consiste à  contrôler la variation des comptes de capitaux propres.",
    actions: "Compléter les colonnes affectation de RST, augmentation et Diminution. Le contrôle doit être OK.",
  },
  "J2": {
    description: "Ce test consite à cadrer les écritures de provision pour démantèlement comptabilisées manuellement avec les justificatifs (fichier client).",
    actions: "Mettre une capture d'écrant ou ajouter en PJ les justificatifs. Si la société n'est pas concernée, commenter \"NC\"",
  },
  "J3": {
    description: "Ce test consite à cadrer les écritures de subvention d'investissement.",
    actions: `
Contrôler la cohérence des soldes.<br/>
1. Contrôler la cohérence des sens des soldes 131* et 139*<br/><br/>
2. Vérifier que le 139* ne soit pas supérieur au 131*<br/><br/>
3. Cadrage de la QP avec le module Immo SAP<br/>
- Renseigner le montant de la simulation (S_ALR_87012936) + insérer une capture d'écran<br/>
- Joindre le fichier excel correspondant
`,
  },
  "PP":{
    description: "Dépot des documents : BG SAP,  Fichier excel CET et Fichier excel RF",
    actions: "",
  }
}
